module.exports = __webpack_public_path__ + "assets/square-cross.4c53611a.svg";